import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, nextTick } from 'vue'
import type { ToggleValue, ToggleOption } from './WheelsToggle.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'WheelsToggle',
  props: {
    value: null,
    options: null,
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    minItemWidth: { default: 120 },
    ariaLabel: { default: 'Toggle' },
    color: { default: 'cu-blue' }
  },
  emits: ["input", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: ToggleValue): void
  (e: 'change', value: ToggleValue): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: ToggleValue, options: ToggleOption[], disabled: boolean, block: boolean, minItemWidth: number | null, ariaLabel: string, color: string };





const btnRefs = ref<HTMLElement[]>([])

const activeIndex = computed(() => {
  const i = props.options.findIndex(o => o.value === props.value)
  return i === -1 ? 0 : i
})

function focusIndex(i: number) {
  nextTick(() => {
    const el = btnRefs.value[i]
    if (el) el.focus()
  })
}

function selectIndex(i: number) {
  const opt = props.options[i]
  if (!opt || props.disabled || opt.disabled) return
  emit('input', opt.value)
  emit('change', opt.value)
}

function nextEnabled(from: number, dir: 1 | -1) {
  const total = props.options.length
  let i = from
  for (let j = 0; j < total; j++) {
    i = (i + dir + total) % total
    const opt = props.options[i]
    if (opt && !opt.disabled) return i
  }
  return from
}

function onKeydown(i: number, e: KeyboardEvent) {
  if (props.disabled) return
  switch (e.key) {
    case 'ArrowRight':
      e.preventDefault()
      focusIndex(nextEnabled(i, 1))
      break
    case 'ArrowLeft':
      e.preventDefault()
      focusIndex(nextEnabled(i, -1))
      break
    case 'Enter':
    case ' ':
      e.preventDefault()
      selectIndex(i)
      break
  }
}

onMounted(() => {
  focusIndex(activeIndex.value)
})

return { __sfc: true,props, emit, btnRefs, activeIndex, focusIndex, selectIndex, nextEnabled, onKeydown }
}

})